export const GET_PROJECT_CONFIGURATION = 'GET_PROJECT_CONFIGURATION';

export function getProjectConfiguration(data) {
  return {
    type: GET_PROJECT_CONFIGURATION,
    data,
  };
}
